var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAnnouncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3203 9.25C22.7345 9.25 23.0703 9.58579 23.0703 10V13C23.0703 13.4142 22.7345 13.75 22.3203 13.75C21.9061 13.75 21.5703 13.4142 21.5703 13V10C21.5703 9.58579 21.9061 9.25 22.3203 9.25Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7881 2.58542C20.0354 2.71479 20.1905 2.97085 20.1905 3.25V19.75C20.1905 20.0292 20.0354 20.2852 19.7881 20.4146C19.5407 20.544 19.242 20.5253 19.0127 20.366L17.9241 19.6101C14.7529 17.4083 11.0661 16.1683 7.27352 16.016C7.44322 17.5197 8.1113 18.9199 9.16834 19.9672C9.46259 20.2587 9.46479 20.7336 9.17326 21.0279C8.88172 21.3221 8.40686 21.3243 8.11261 21.0328C6.76261 19.6952 5.93581 17.9046 5.76398 16H5.77H6.47876H6.48211H7.27V15.9841V7H6.48752C10.5552 6.99818 14.5342 5.74352 17.9241 3.38993L19.0127 2.63397C19.242 2.47475 19.5407 2.45604 19.7881 2.58542ZM6.4804 7C6.713 7 6.92095 7.10588 7.0586 7.27207C6.92236 7.10756 6.71724 7.00213 6.48752 7H5.77H4.3207C1.8897 7 -0.0292969 9.04387 -0.0292969 11.5C-0.0292969 13.9561 1.8897 16 4.3207 16H5.76398C5.74158 15.7517 5.73031 15.5014 5.73047 15.25V7.75C5.73047 7.66573 5.74437 7.5847 5.77 7.50909V7L6.4804 7Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73047 7.75V15.25C5.73052 15.1659 5.74442 15.085 5.77 15.0095V7.50909C5.74437 7.5847 5.73047 7.66573 5.73047 7.75Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77 15.0095C5.74442 15.085 5.73052 15.1659 5.73047 15.25C5.73047 15.3343 5.74437 15.4153 5.77 15.4909V15.0095Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77 16V15.4909C5.74437 15.4153 5.73047 15.3343 5.73047 15.25C5.73031 15.5014 5.74158 15.7517 5.76398 16H5.77Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnnouncement);
export default __webpack_public_path__ + "static/media/icon-announcement.5e553b14.svg";
export { ForwardRef as ReactComponent };